import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface PropertyUsp1xPhotoModel extends BaseModel {
  variables?: { [key: string]: string } | PropertyUsp1xPhotoVariables;
}

export interface PropertyUsp1xPhotoVariables {
  PropertyUsp1xImgDesktop: string;
  PropertyUsp1xImageMobile: string;
  PropertyUsp1xImageHref: string;
  PropertyUsp1xImageAlt: string;
  PropertyUsp1xName: string;
  PropertyUsp1x1Usp: string;
  PropertyUsp1x2Usp: string;
  PropertyUsp1x3Usp: string;
  PropertyUsp1xCtaLink: string;
  PropertyUsp1xCtaText: string;
  PropertyUsp1xImageHrefSegmentRegex: string;
}

export class PropertyUsp1xPhotoInitVariables implements PropertyUsp1xPhotoVariables {
  PropertyUsp1xImgDesktop = '';
  PropertyUsp1xImageMobile = '';
  PropertyUsp1xImageHref = '';
  PropertyUsp1xImageAlt = '';
  PropertyUsp1xName = '';
  PropertyUsp1x1Usp = '';
  PropertyUsp1x2Usp = '';
  PropertyUsp1x3Usp = '';
  PropertyUsp1xCtaLink = '';
  PropertyUsp1xCtaText = '';
  PropertyUsp1xImageHrefSegmentRegex = '';
}

export class PropertyUsp1xPhotoInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new PropertyUsp1xPhotoInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
